import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { validInteger } from 'app/helpers/numberHelper';
import { IChildren } from 'app/models/Placement/PlacementMods';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditPreferenceChildrenRows,
  selectExpandedModsDialog,
  selectPreferenceChildrenAgeError,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { findIndex, findRow } from '../AdultGridComponents/AdultNameCell';
import { getDisplayValue } from '../utils';

interface GridCellProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const ChildrenAgeCell = (cellParams: GridRenderEditCellParams) => {
  return (
    <>
      <ChildrenAge cellParams={cellParams} />
    </>
  );
};

const ChildrenAge = React.memo(function ChildrenAge(cellParams: GridCellProps) {
  const { control } = useFormContext();
  const dispatch = useDispatch();

  const isExpanded = useSelector(selectExpandedModsDialog);
  const editPreferenceChildrenRequests = useSelector(selectEditPreferenceChildrenRows);
  const preferenceChildrenAgeError = useSelector(selectPreferenceChildrenAgeError);

  const RowId = cellParams?.cellParams?.id;
  const rowData = getDisplayValue(RowId, editPreferenceChildrenRequests);
  const age = rowData?.age;
  const [childrenAge, setChildrenAge] = useState(age === '--' ? null : age);

  const setAgeForChildrenGridEdit = data => {
    let newRows = editPreferenceChildrenRequests.slice(0);
    let childrenGridEditRow = findRow(editPreferenceChildrenRequests, RowId);

    let updatedAge = {} as IChildren;

    updatedAge = {
      ...childrenGridEditRow,
      age: data ? parseInt(data) : '',
    };

    let editAgeIndex = findIndex(editPreferenceChildrenRequests, RowId);
    newRows[editAgeIndex] = updatedAge;
    dispatch(placementModsAction.setEditChildrenRows(newRows));
  };

  //UPDATE THE ERROR
  useEffect(() => {
    if (cellParams?.cellParams?.error !== null && cellParams?.cellParams?.error !== undefined) {
      const val = preferenceChildrenAgeError?.filter(el => el.id === cellParams?.cellParams?.id);

      if (val?.length === 0) {
        const arr = preferenceChildrenAgeError?.length > 0 ? preferenceChildrenAgeError?.slice(0) : [];
        const valueObj = { age: cellParams?.cellParams?.error, id: cellParams?.cellParams?.id };

        arr.push(valueObj);

        dispatch(placementModsAction.setPreferenceChildrenAgeError(arr));
      } else {
        const arr = preferenceChildrenAgeError?.slice(0);
        let currentObj = arr.find(v => v.id === cellParams?.cellParams?.id);

        let updatedObj = { ...currentObj, age: cellParams?.cellParams?.error };

        let editIndex = arr.findIndex(v => v.id === cellParams?.cellParams?.id);

        arr[editIndex] = updatedObj;

        dispatch(placementModsAction.setPreferenceChildrenAgeError(arr));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cellParams?.cellParams?.error]);

  return (
    <>
      <Controller
        name={`childrenGrid${RowId}.age`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <TextField
            required={true}
            variant="outlined"
            size={'small'}
            sx={{
              width: isExpanded ? '852px' : '274px',
            }}
            value={childrenAge}
            onBlur={e => {
              if (validInteger(e.target.value, { numberLength: 4 })) {
                setAgeForChildrenGridEdit(e.target.value);
              }
              onChange(e.target.value);
            }}
            onChange={e => {
              if (e.target.value) {
                if (validInteger(e.target.value, { numberLength: 4 }))
                  setChildrenAge(!Number.isNaN(e.target.value) ? e.target.value : '');
                onChange(e.target.value);
              } else {
                setChildrenAge('');
              }
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
